import React from 'react';
import { NACHWEIS_POSITION_STATUS, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { MATreeStructureAbschluss } from '../default-content/abschluss-seite/MATreeStructureAbschluss';
import { TreeStructureAnlagenMA } from '../default-content/anlagen/TreestructureAnlagenMA';
import { TreeStructureErklaerungMA } from '../default-content/erklaerung/TreestructureErklaerungMA';
import { getFormStrucStammdatenblattMA } from '../default-content/stammdatenblatt/content/StammdatenblattMA';
import { TreeStructureWichtigeHinweiseMA } from '../default-content/wichtige-hinweise/TreeStructureWichtigeHinweiseMA';
import { MittelabrufKreativMA } from './content/MittelabrufKreativMA';
import ProjektDatenKreativMA from './content/Projektdaten';
import UebersichtBewilligungKreativMA from './content/UebersichtBewilligung';
import PersonalAusgabenKreativMA from './content/personal-ausgaben/PersonalAusgabenKreativMA';
import PersonalKostenUebersichtKreativMA from './content/personal-ausgaben/PersonalKostenUebersichtKreativMA';
import SachAusgabenKreativMA from './content/sachausgaben/SachausgabenKreativMA';
import SachausgabenUebersichtKreativMA from './content/sachausgaben/SachausgabenUebersichtKreativMA';

export const TreeStructureMAKreativ = (application: any) => {
	let treeNodes: TreeNodeType[] = [
		...TreeStructureWichtigeHinweiseMA(application),
		{
			label: 'Projektdaten',
			content: <ProjektDatenKreativMA />,
			formStruc: getFormStrucStammdatenblattMA(application),
		},
		{
			label: 'Übersicht Bewilligung',
			content: <UebersichtBewilligungKreativMA />,
		},
		...PersonalAusgabenStruktur(application),
		...SachAusgabenStruktur(application),
		{
			label: 'Mittelabruf',
			content: <MittelabrufKreativMA />,
		},
		...TreeStructureAnlagenMA(application),
		...TreeStructureErklaerungMA(application),
		...MATreeStructureAbschluss(application),
	];

	return treeNodes;
};

const PersonalAusgabenStruktur = (_application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Personalausgaben',
			content: <ApplicationHeading title='Personalausgaben' description={PLATZHALTER_TEXT} />,
			children: [
				{
					label: 'Angefallene Personalausgaben',
					content: <PersonalAusgabenKreativMA nachweisPositionStatus={NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben} />,
				},
				{
					label: 'Geplante Personalausgaben',
					content: <PersonalAusgabenKreativMA nachweisPositionStatus={NACHWEIS_POSITION_STATUS.geplant} />,
				},
			],
		},
		{
			label: 'Personalausgaben Übersicht',
			content: <PersonalKostenUebersichtKreativMA />,
		},
	];

	return treeNodes;
};
const SachAusgabenStruktur = (_application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Sachausgaben',
			content: <ApplicationHeading title='Sachausgaben' description={PLATZHALTER_TEXT} />,
			children: [
				{
					label: 'Angefallene Sachausgaben',
					content: <SachAusgabenKreativMA nachweisPositionStatus={NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben} />,
				},
				{
					label: 'Geplante Sachausgaben',
					content: <SachAusgabenKreativMA nachweisPositionStatus={NACHWEIS_POSITION_STATUS.geplant} />,
				},
			],
		},
		{
			label: 'Sachausgaben Übersicht',
			content: <SachausgabenUebersichtKreativMA />,
		},
	];

	return treeNodes;
};
